// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router'

export class Header extends Component {
    render() {
        if (!window.sessionStorage.getItem('authToken')) {
            return (
                <header>
                    <Row>
                        <Col smOffset={2} sm={3}>
                            <div className="wrapper logo">
                                <Link to='/' >
                                    <img src="/assets/images/Enabler_small.png" alt="Enabler Interactive" />
                                </Link>
                            </div>
                        </Col>
                        <Col sm={5}>
                            <nav className="pre-login">
                                <a href="https://www.enablerinteractive.com">Home</a>
                                <a href="https://www.enablerinteractive.com/about">About</a>
                                <a href="https://www.enablerinteractive.com/topics">Topics</a>
                                <a href="https://www.enablerinteractive.com/contact">Contact</a>
                                <Link to='/login' activeClassName="active-nav-link">Login</Link>
                            </nav>
                        </Col>
                    </Row>
                </header>
            )
        }
        else {
            return (
                <header className="hidden">
                </header>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/header.js